import TopNav from "ui/dashboard/topnav";
import SiteList from "../cameraMap/site-list";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "context/AuthContext";
import TemplateSelector from "../schedule/components/templateSelector";
import "./style.scss";
import Schedule from "ui/automation/schedule";
import { Button, Select } from "antd";
import PresetSetting from "./components/presetSetting";
import { getSiteList } from "../cameraMap/service";
import { getSchedule, saveSchedule } from "./service";
import { showToast } from "ui/components/common";
import { getTemplateList } from "../virtualGuardTemplate/service";
import _ from "lodash";
export default function VirtualGuardPage() {
  const [sites, setSites] = useState([]);
  const [timeInterval, setTimeInterval] = useState(0);
  const { user } = useContext(AuthContext);
  const [selectedCamera, setSelectedCamera] = useState(null);
  const [selectedSite, setSelectedSite] = useState(null);
  const [schedules, setSchedules] = useState([]);
  const [scheduleSaveLoading, setScheduleSaveLoading] = useState(false);
  const [scheduleLoading, setScheduleLoading] = useState(false);
  const [scheduleTemplates, setScheduleTemplates] = useState([]);
  useEffect(() => {
    getSiteList(user.orgId).then((data) => {
      setSites(data.data.sites);
    });
    getTemplateList("schedule").then((data) => {
      if (data.status !== 200) {
        showToast(1, "Failed to fetch schedule templates");
      } else {
        setScheduleTemplates(
          data.data?.data?.map((template) => ({
            label: template.name,
            schedules: template.schedules,
            checkInterval: template.checkInterval,
            key: template.id,
          })),
        );
      }
    });
  }, []);
  function onSaveSchedule() {
    setScheduleSaveLoading(true);
    saveSchedule(selectedCamera.id, timeInterval, schedules)
      .then((data) => {
        if (data.status !== 200) {
          showToast(1, "Failed to save schedule");
        } else {
          showToast(0, "Schedule saved successfully");
        }
      })
      .finally(() => {
        setScheduleSaveLoading(false);
      });
  }
  function onScheduleTemplateClick(schedule, interval) {
    setSchedules(_.cloneDeep(schedule || []));
    setTimeInterval(interval);
  }
  useEffect(() => {
    if (!selectedCamera) return;
    setScheduleLoading(true);
    // fetch schedule
    getSchedule(selectedCamera.id)
      .then((data) => {
        if (data.status !== 200) {
          showToast(1, "Failed to fetch schedule");
          return;
        }
        setTimeInterval(data.data.checkInterval);
        setSchedules(data.data.schedules);
      })
      .finally(() => setScheduleLoading(false));
  }, [selectedCamera]);
  return (
    <>
      <TopNav title="Inspector Configuration"></TopNav>
      <div className="virtualGuard flex h-full flex-col md:flex-row md:overflow-hidden bg-white rounded-3xl mr-6 mb-6">
        <div className="w-full flex-none md:w-96 overflow-y-auto border-r border-neutral-200 p-5">
          <SiteList
            withCapabilities={"inspection"}
            sites={sites}
            currentCamera={selectedCamera}
            onSelectSite={setSelectedSite}
            orgId={+user?.orgId}
            onCameraClick={setSelectedCamera}
            locations={[]}
            currentSite={selectedSite}
            hideOffline={true}
          />
        </div>
        <div
          className="flex-grow flex relative"
          style={{ overflowY: "hidden", overflowX: "auto" }}
        >
          {!selectedCamera && (
            <div
              className="mask"
              style={{
                zIndex: 99,
                textAlign: "center",
                backgroundColor: "white",
              }}
            >
              <div
                style={{ color: "black", fontWeight: "600", fontSize: "20px" }}
              >
                Select a Camera to Configure
              </div>
              <div style={{ color: "black" }}>
                Choose a camera from the list on the left to view and edit its
                preset configurations.
              </div>
            </div>
          )}
          {selectedCamera && (
            <>
              <div
                className={`flex-grow relative ${selectedCamera && !scheduleLoading && "border-r"} border-neutral-200`}
              >
                <div className="w-full h-full rounded-3xl bg-white relative">
                  <PresetSetting
                    selectedSite={selectedSite}
                    selectedCamera={selectedCamera}
                    onFailToFetchPresetList={() => setSelectedCamera(null)}
                  />
                </div>
              </div>
              <div
                className={`flex flex-col w-full flex-none  p-5 relative`}
                style={{ justifyContent: "space-between", width: "437px" }}
              >
                {(!selectedCamera || scheduleLoading) && (
                  <div
                    className="mask"
                    style={{ zIndex: 2, backgroundColor: "white" }}
                  ></div>
                )}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    flex: "1",
                    overflow: "auto",
                  }}
                >
                  <div style={{ width: "100%" }}>
                    <span>Patrol Schedule</span>
                    <span style={{ float: "right" }}>
                      <TemplateSelector
                        templateList={scheduleTemplates}
                        onApply={(e) => {
                          onScheduleTemplateClick(
                            e.item.props.schedules,
                            e.item.props.checkInterval,
                          );
                        }}
                      />
                    </span>
                  </div>
                  <Schedule
                    alertSchedules={schedules}
                    setAlertSchedules={setSchedules}
                  />
                  <div style={{ marginTop: "16px" }}>{"Time Interval"}</div>
                  <div style={{ width: "100%" }}>
                    <Select
                      style={{
                        width: "100%",
                        height: "54px",
                        marginTop: "8px",
                      }}
                      options={[
                        { label: "No Run", value: 0 },
                        { label: "5 min", value: 5 * 60 },
                        { label: "15 mins", value: 15 * 60 },
                        { label: "30 min", value: 30 * 60 },
                        { label: "60 min", value: 60 * 60 },
                      ]}
                      value={timeInterval}
                      onChange={setTimeInterval}
                    />
                  </div>
                </div>
                <Button
                  loading={scheduleSaveLoading}
                  onClick={onSaveSchedule}
                  className="primaryButton"
                  style={{
                    alignSelf: "center",
                    flex: "none",
                    marginTop: "16px",
                  }}
                >
                  Save
                </Button>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}
